import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { AddBackgroundRequest, DesignTemplateSummary } from "./dtos";

const DESIGN_TEMPLATE_SERVICE = `${Constants.API_URL}/bedrock/design_templates`;

export class DesignTemplateServices {
  /** Attaches a library asset to the slide version, appended last. */
  @scCatchServiceException(true)
  static async attachBackground(templateId: number, assetId: number): Promise<DesignTemplateSummary> {
    const request: AddBackgroundRequest = { assetId };
    const { data } = await axios.post<DesignTemplateSummary>(
      `${DESIGN_TEMPLATE_SERVICE}/${templateId}/backgrounds`,
      request
    );
    return data;
  }

  @scCatchServiceException(true)
  static async removeBackground(templateId: number, assetId: number): Promise<DesignTemplateSummary> {
    const { data } = await axios.delete<DesignTemplateSummary>(
      `${DESIGN_TEMPLATE_SERVICE}/${templateId}/backgrounds/${assetId}`
    );
    return data;
  }

  @scCatchServiceException(true)
  static async setDefaultBackground(templateId: number, assetId: number): Promise<DesignTemplateSummary> {
    const { data } = await axios.put<DesignTemplateSummary>(
      `${DESIGN_TEMPLATE_SERVICE}/${templateId}/backgrounds/default`,
      { assetId }
    );
    return data;
  }
}
